import { render, staticRenderFns } from "./treasury-form-409.vue?vue&type=template&id=2bb9d12e&scoped=true&"
import script from "./treasury-form-409.vue?vue&type=script&lang=js&"
export * from "./treasury-form-409.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9d12e",
  null
  
)

export default component.exports